import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { CircularProgress } from '@mui/material';

interface ConnectionStatusIconProps {
  /** Whether connection test is in progress */
  checking: boolean;
  /** Connection test result ('200 OK', '404 Error', etc.) */
  result: string | null;
  /** Size of the icon in pixels */
  size?: number;
}

/**
 * Connection status indicator icon
 *
 * Matches dataProtect CredBar.js EnvCheckIcons component EXACTLY:
 * - checking → spinner
 * - result === "200 OK" → green circle
 * - result (truthy but not "200 OK") → red triangle
 * - result falsy → no icon
 *
 * @example
 * <ConnectionStatusIcon checking={isChecking} result="200 OK" />
 * <ConnectionStatusIcon checking={false} result="404 Error" />
 * <ConnectionStatusIcon checking={true} result={null} />
 */
export const ConnectionStatusIcon = ({
  checking,
  result,
  size = 20,
}: ConnectionStatusIconProps) => {
  if (checking) {
    return <CircularProgress size={size} />;
  }

  if (!result) {
    return null;
  }

  if (result === '200 OK') {
    return <CheckCircleIcon sx={{ color: '#00853E', fontSize: size + 4 }} />;
  }

  // Any other truthy result → red error icon
  return <ErrorIcon sx={{ color: '#EA5A5A', fontSize: size + 4 }} />;
};
